import { render, staticRenderFns } from "./queues.vue?vue&type=template&id=bbc632c6&"
import script from "./queues.vue?vue&type=script&lang=js&"
export * from "./queues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports